import { type QuestionData, type QuestionId } from '@terros/common'
import { useQueryClient } from '@tanstack/react-query'
import { questionKey, questionsKey } from '../keys'

export function useQuestionCache() {
  const queryClient = useQueryClient()

  return {
    clearItem: (questionId: QuestionId) => {
      queryClient.invalidateQueries({ queryKey: questionKey(questionId) })
    },
    clearList: () => {
      queryClient.invalidateQueries({ queryKey: questionsKey() })
    },
    removeItem: (questionId: QuestionId) => {
      queryClient.invalidateQueries({ queryKey: questionKey(questionId) })
      queryClient.setQueriesData<QuestionData[]>({ queryKey: questionsKey() }, (oldData) => {
        if (!oldData) return
        const updatedData = oldData.filter((q) => q.questionId !== questionId)
        return updatedData
      })
      queryClient.invalidateQueries({ queryKey: questionsKey() })
    },
  }
}
